<div *ngIf="!isMobile" class="marker-div">
  <mat-toolbar class="navbar {{ !isCollapsed ? 'navbar-margin' : '' }}">
    <mat-toolbar-row class="navbar__row inspiration" *ngIf="catId === '5'">
      <div class="navbar__row__content">
        <h2>{{ 'InspirationTitle' | translate }}</h2>
        <p>{{ 'InspirationResSubTitle' | translate }}</p>
      </div>
      <button
        class="filter-button"
        mat-raised-button
        color="accent"
        (click)="editInspirationTags()"
      >
        <mat-icon>edit</mat-icon>
        {{ 'InspirationResEditButton' | translate }}
      </button>
    </mat-toolbar-row>
    <mat-toolbar-row *ngIf="catId === '5' && inspirationTags">
      <mat-chip-list>
        <ng-container *ngFor="let option of inspirationTags; let index = index">
          <mat-chip
            class="chip chip-tag mat-standard-chip"
            (removed)="removeInspirationTage(index)"
            *ngIf="option !== undefined && option !== null"
          >
            {{ option.responseTitle }}
            <mat-icon class="chip-tag" matChipRemove>cancel</mat-icon>
          </mat-chip>
        </ng-container>
      </mat-chip-list>
    </mat-toolbar-row>
    <mat-toolbar-row class="navbar__row">
      <button
        *ngIf="isCollapsed"
        mat-flat-button
        color="warn"
        class="reduce-list fs-border"
        (click)="reduce()"
        style="margin-right: 1rem"
      >
        <mat-icon>chevron_right</mat-icon>
        <span translate="">ShowMap</span>
      </button>
      <span>
        <span class="result-nb">{{ nbResults ? nbResults : '0' }}</span>
        <span *ngIf="catId !== '5'" class="centered result-p" translate=""
          >Results</span
        >
        <span *ngIf="catId === '5'" class="centered result-p">Suggestions</span>
      </span>
      <mat-divider fxFlex=""></mat-divider>
      <button
        *ngIf="!filterDisabled"
        class="filter-button"
        mat-raised-button
        (click)="activateFilter()"
        color="accent"
        [disabled]="filterDisabled"
        [matBadgeHidden]="filterCount < 1"
        [matBadge]="filterCount"
        matBadgeSize="large"
        matBadgePosition="after"
      >
        <mat-icon>tune</mat-icon>
        {{ 'Filters' | translate }}
      </button>
      <button
        *ngIf="filterDisabled"
        class="refresh-data"
        mat-raised-button
        (click)="getNewSuggestions()"
        color="accent"
        matBadgeSize="large"
        matBadgePosition="after"
      >
        <mat-icon>sync</mat-icon>
        Voir 10 autres suggestions
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <cdk-virtual-scroll-viewport
    *ngIf="pageContent.length > 0 || catId !== '5'"
    fxFlex=""
    class="marker-list"
    itemSize="100"
  >
    <mat-grid-list
      [style.marginLeft]="isCollapsed ? '' : '3rem'"
      cols="{{
        isCollapsed && currentScreenWidth >= 800
          ? currentScreenWidth < 1400
            ? 3
            : 4
          : 2
      }}"
      rowHeight="330px"
    >
      <mat-grid-tile
        colspan="1"
        rowspan="1"
        *ngFor="let mc of pageContent; trackBy: identify"
      >
        <a
          (click)="goToFicheDetail(mc); sendGaEventIfSuggestion(catId, mc)"
          style="width: 100%"
          [title]="mc.title"
        >
          <mat-card
            class="hover-card"
            style="height: 100%; width: 100%"
            (mouseover)="onOver(mc)"
            (mouseleave)="closeOnOver()"
          >
            <mat-card-content (click)="setUrl()">
              <div
                *ngIf="
                  mc.category == '3' &&
                  checkIfDateIsCurrentOrFuture(mc?.dateStart, mc?.dateEnd)
                "
                class="event-date date-font"
              >
                <div *ngIf="checkIfDateIsCurrent(mc?.dateStart, mc?.dateEnd)">
                  {{ 'currently' | translate }}
                </div>
                <div
                  *ngIf="!checkIfDateIsCurrent(mc?.dateStart, mc?.dateEnd)"
                  class="date-content"
                >
                  <div
                    *ngIf="checkIfDateIsInterval(mc?.dateStart, mc?.dateEnd)"
                  >
                    <div style="margin-bottom: 10px">
                      {{ formatDate(mc.dateStart, 'short') }}
                    </div>
                    <mat-divider></mat-divider>
                    <div style="margin-top: 10px">
                      {{ formatDate(mc.dateEnd, 'short') }}
                    </div>
                  </div>
                  <div
                    *ngIf="!checkIfDateIsInterval(mc?.dateStart, mc?.dateEnd)"
                  >
                    <div>
                      {{ formatDate(mc.dateStart, 'long') }}
                    </div>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="mc.category == '1'">
                <div class="poi-circuit-difficulty" *ngIf="mc.difficulty">
                  {{ mc.difficulty.name }}
                </div>
                <div class="circuit-div">
                  <div class="poi-circuit-chip">
                    <img
                      *ngIf="mc.isLoop"
                      class="img-loop"
                      src="assets/icons/icon_loop.png"
                      aria-hidden="true"
                    />
                    <img
                      *ngIf="!mc.isLoop"
                      class="img-loop img-linear"
                      src="assets/icons/icon_lineaire.png"
                      aria-hidden="true"
                    />
                    {{ mc.distance }} Km
                  </div>
                  <div class="poi-circuit-chip">
                    <mat-icon>schedule</mat-icon>
                    {{ getDurationStringified(mc.duration) }}
                  </div>
                </div>
              </ng-container>
              <div style="text-align: center">
                <img
                  #img
                  mat-card-image
                  class="list-card-img"
                  style="padding: 0"
                  [src]="getCurrentImage(mc)"
                  (error)="manageImageError(mc, img)"
                  alt="{{ mc.image?.alt }}"
                />
              </div>
              <div class="card-title-div">
                <div class="card-title-div-text">
                  <mat-card-title
                    class="poi-title"
                    [innerHTML]="mc.title"
                  ></mat-card-title>
                  <mat-card-subtitle class="poi-subtitle"
                    >{{ mc.city.name }}
                  </mat-card-subtitle>
                </div>
                <!-- SEPARATOR -->
                <div class="card-title-div-button">
                  <div class="mat-mini-fab card-list-button">
                    <mat-icon svgIcon="{{ getCurrentIcon(mc) }}"></mat-icon>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </a>
      </mat-grid-tile>
    </mat-grid-list>
  </cdk-virtual-scroll-viewport>
  <mat-paginator
    #paginator
    [length]="miniCard.length"
    [pageSizeOptions]="pageSize"
    (page)="swapPage($event)"
    aria-label="Select page"
    *ngIf="catId !== '5'"
  >
  </mat-paginator>
  <div
    *ngIf="pageContent.length == 0 && catId === '5'"
    class="inspiration-no-results"
  >
    <div class="inspiration-no-results__content">
      <img
        class="inspiration-no-results__image"
        src="assets/logos/logo_aucun_resultat.png"
        alt="Aucun résultat"
        aria-hidden="true"
      />
      <div class="inspiration-no-results__title">
        On ne va pas y aller par 4 chemins...
      </div>
      <div class="inspiration-no-results__description">
        Aucune suggestion ne correspond à votre recherche. Réessayez en appuyant
        sur <mat-icon>edit</mat-icon> pour modifier les critères
      </div>
    </div>
  </div>
</div>

<div *ngIf="isMobile" class="marker-div">
  <div
    *ngIf="catId === '5' && inspirationTags"
    class="mobile-inspiration-results"
  >
    <div *ngIf="catId === '5'" class="title-cat">
      <button
        class="filter-button"
        mat-raised-button
        color="accent"
        (click)="editInspirationTags()"
      >
        <mat-icon>edit</mat-icon>
      </button>
      <p class="mobile-inspiration-results__title">Suggestions de balade</p>
      <p class="mobile-inspiration-results__description">
        D'après vos réponses, cette sélection devrait vous plaire.
      </p>
    </div>
    <mat-chip-list>
      <ng-container *ngFor="let option of inspirationTags; let index = index">
        <mat-chip
          class="chip chip-tag mat-standard-chip"
          (removed)="removeInspirationTage(index)"
          *ngIf="option !== undefined && option !== null"
        >
          {{ option.responseTitle }}
          <mat-icon class="chip-tag" matChipRemove>cancel</mat-icon>
        </mat-chip>
      </ng-container>
    </mat-chip-list>
  </div>
  <mat-toolbar *ngIf="catId !== '5'" class="navbar-sp">
    <div class="search-space" fxFlex=""></div>
    <div class="title-cat">
      <span class="cat">{{ title ? (title[0] | translate) : '' }}</span>
      <span class="sub-cat"
        >.
        {{
          title && title[1] ? (title[1] | translate) : ('All' | translate)
        }}</span
      >
    </div>
    <div class="list-header-sp">
      <p
        class="centered-sp result-nb"
        style="text-align: right; margin-right: 0"
      >
        {{ nbResults ? nbResults : '0' }}
      </p>
      <p class="centered-sp result-p" translate="">Results</p>
      <button
        *ngIf="catId === '5'"
        class="mobile-refresh-data"
        mat-raised-button
        (click)="getNewSuggestions()"
        color="accent"
        matBadgeSize="large"
      >
        <mat-icon>sync</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-toolbar
    *ngIf="catId === '5'"
    class="navbar-sp mobile-inspiration-results__bar"
  >
    <div class="search-space" fxFlex=""></div>
    <div class="list-header-sp">
      <p
        class="centered-sp result-nb"
        style="text-align: right; margin-right: 0"
      >
        {{ nbResults ? nbResults : '0' }}
      </p>
      <p class="centered-sp result-p" translate="">Suggestions</p>
      <mat-divider fxFlex=""></mat-divider>
      <button
        *ngIf="catId === '5'"
        class="mobile-refresh-data"
        mat-raised-button
        (click)="getNewSuggestions()"
        color="accent"
        matBadgeSize="large"
      >
        <mat-icon>sync</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <cdk-virtual-scroll-viewport
    *ngIf="pageContent.length > 0 || catId !== '5'"
    fxFlex=""
    class="marker-list"
    itemSize="100"
  >
    <mat-grid-list cols="1" rowHeight="230px">
      <mat-grid-tile
        colspan="1"
        rowspan="1"
        *ngFor="let mc of pageContent; trackBy: identify"
      >
        <a
          (click)="goToFicheDetail(mc); sendGaEventIfSuggestion(catId, mc)"
          style="width: 100%"
          [title]="mc.title"
        >
          <mat-card style="height: 100%; width: 100%; padding: 2rem">
            <mat-card-content (click)="setUrl()">
              <div
                *ngIf="
                  mc.category == '3' &&
                  checkIfDateIsCurrentOrFuture(mc?.dateStart, mc?.dateEnd)
                "
                class="event-date date-font"
              >
                <div *ngIf="checkIfDateIsCurrent(mc?.dateStart, mc?.dateEnd)">
                  {{ 'currently' | translate }}
                </div>
                <div
                  *ngIf="!checkIfDateIsCurrent(mc?.dateStart, mc?.dateEnd)"
                  class="date-content"
                >
                  <div
                    *ngIf="checkIfDateIsInterval(mc?.dateStart, mc?.dateEnd)"
                  >
                    <div style="margin-bottom: 10px">
                      {{ formatDate(mc.dateStart, 'short') }}
                    </div>
                    <mat-divider></mat-divider>
                    <div style="margin-top: 10px">
                      {{ formatDate(mc.dateEnd, 'short') }}
                    </div>
                  </div>
                  <div
                    *ngIf="!checkIfDateIsInterval(mc?.dateStart, mc?.dateEnd)"
                  >
                    <div>
                      {{ formatDate(mc.dateStart, 'long') }}
                    </div>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="mc.category == '1'">
                <div
                  class="poi-circuit-difficulty -mobile"
                  *ngIf="mc.difficulty"
                >
                  {{ mc.difficulty.name }}
                </div>
                <div class="circuit-div-sp">
                  <div class="poi-circuit-chip">
                    <img
                      *ngIf="mc.isLoop"
                      class="img-loop"
                      src="assets/icons/icon_loop.png"
                      aria-hidden="true"
                    />
                    <img
                      *ngIf="!mc.isLoop"
                      class="img-loop img-linear"
                      src="assets/icons/icon_lineaire.png"
                      aria-hidden="true"
                    />
                    {{ mc.distance }} Km
                  </div>
                  <div class="poi-circuit-chip">
                    <mat-icon>schedule</mat-icon>
                    {{ getDurationStringified(mc.duration) }}
                  </div>
                </div>
              </ng-container>
              <div style="text-align: center">
                <img
                  #img_sp
                  mat-card-image
                  class="list-card-img"
                  style="padding: 0"
                  [src]="getCurrentImage(mc)"
                  (error)="manageImageError(mc, img_sp)"
                  alt="{{ mc?.image?.alt }}"
                />
              </div>
              <div class="card-title-div">
                <div fxFlex="">
                  <mat-card-title
                    class="poi-title"
                    [innerHTML]="mc.title"
                  ></mat-card-title>
                  <mat-card-subtitle class="poi-subtitle"
                    >{{ mc.city.name }}
                  </mat-card-subtitle>
                </div>
                <div class="cat-icon-button mat-mini-fab card-list-button">
                  <mat-icon svgIcon="{{ getCurrentIcon(mc) }}"></mat-icon>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </a>
      </mat-grid-tile>
    </mat-grid-list>
  </cdk-virtual-scroll-viewport>
  <mat-paginator
    #paginator
    class="paginator-sp"
    [length]="miniCard.length"
    [pageSizeOptions]="pageSize"
    (page)="swapPage($event)"
    aria-label="Select page"
    *ngIf="catId !== '5'"
  ></mat-paginator>
  <div
    *ngIf="pageContent.length == 0 && catId === '5'"
    class="mobile-inspiration-no-results"
  >
    <div class="mobile-inspiration-no-results__content">
      <img
        class="mobile-inspiration-no-results__image"
        src="assets/logos/logo_aucun_resultat.png"
        alt="Aucun résultat"
        aria-hidden="true"
      />
      <div class="mobile-inspiration-no-results__title">
        On ne va pas y aller par 4 chemins...
      </div>
      <div class="mobile-inspiration-no-results__description">
        Aucune suggestion ne correspond à votre recherche. Réessayez en appuyant
        sur <mat-icon>edit</mat-icon> pour modifier les critères
      </div>
    </div>
  </div>
</div>
